module.exports = __webpack_public_path__ + "img/av024.6a70f15b.png";